export default __webpack_public_path__ + "static/Eco_schools-ff669f8a75862f50f3c6fc44abd9303c.mp4";